import React from "react";
import ReactDOM from "react-dom";
import App from "./components/mathGenerator";
import * as serviceWorker from "./helpers/serviceWorker";
import "@fortawesome/fontawesome-free/css/all.min.css";

// pledges
import gift from "./images/quote-gift.png";
import mistakes from "./images/quote-mistakes.png";
import noLimit from "./images/quote-no-limit.png";

// intro images
import browser1 from "./images/browser-header.png";
import mobile1 from "./images/mobile-header.png";

function PreloadImages() {
  return (
    <div id="preloaded">
      {/* pledges */}
      <img rel="preload" href={gift} crossOrigin="anonymous" alt="" />
      <img rel="preload" href={mistakes} crossOrigin="anonymous" alt="" />
      <img rel="preload" href={noLimit} crossOrigin="anonymous" alt="" />

      {/* misc */}
      <img rel="preload" href={browser1} alt="" />
      <img rel="preload" href={mobile1} alt="" />
    </div>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <App />
    <PreloadImages />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
